import { downloadCsv } from "../../../utils/downloadCsv";
import { encodeForCSV } from "../../../utils/csvFormatter";
import { ToastService } from "../../../utils/toastify";
import { languageService } from "../../../Language/language.service";
import { versionInfo } from "../../MainPage/VersionInfo";
export const WorkGangCSVMethod = (allExecs, title) => {
  let gangFormData = new Map();
  allExecs.forEach((execution) => {
    const tasks = execution.tasks;
    tasks.forEach((t) => {
      t.maintenance &&
        t.maintenance.length !== 0 &&
        t.maintenance.forEach((m) => {
          let workGangForm = m.appForms && m.appForms.find((f) => f && f.id === "workGangAppForm_m");
          if (!workGangForm || !workGangForm.form) return;
          let tableField = workGangForm.form.find((ff) => ff && ff.id === "workerstable");
          if (!tableField || !tableField.value) return;

          for (let tableRow of tableField.value) {
            if (!tableRow.form) continue;
            if (tableRow.removed) continue;
            let foundEmpNField = tableRow.form.find((field) => field && field.id === "Employee");
            let foundTimeField = tableRow.form.find((field) => field && field.id === "time");
            if (!foundEmpNField) continue;
            let employeeName = encodeForCSV(foundEmpNField.value);
            let timeWorked = foundTimeField ? parseFloat(foundTimeField.value) || 0 : 0;
            if (gangFormData.has(employeeName)) {
              gangFormData.set(employeeName, gangFormData.get(employeeName) + timeWorked);
            } else {
              gangFormData.set(employeeName, timeWorked);
            }
          }
        });
    });
  });

  let finalGangData = Array.from(gangFormData, ([employee, totalTime]) => ({
    Employee: employee,
    "Total Time (hrs)": totalTime,
  }));

  if (finalGangData.length > 0) {
    //downloadCsv(dataForCsvExport, document, getValidFileName(`WorkOrderList-${dataFormatters.dateTimeFormatterWithoutSecs(new Date())}`));
    downloadCsv(finalGangData, document, `WorkGang-${title}`, "completed");
  } else {
    ToastService.Error("Error:", `${languageService("Work Gang is Empty!")}`);
  }
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/WorkGangCSV.js